import React from 'react';
import { List } from '@phosphor-icons/react';
import classNames from 'classnames';

import { URL } from '../../../constants';

import { useUserStore } from '../../../stores/user';

import { Button, ButtonLink, Logo } from '../../general';

interface Props {
  hasSideNav: boolean;
  toggleSideNav: () => void;
  variant?: 'grey' | 'transparent';
}

const Header: React.FC<Props> = (props) => {
  const { hasSideNav, toggleSideNav, variant } = props;

  const { user, accessToken } = useUserStore();

  const pathname = window.location.pathname;

  const onLoginClick = () => {
    if (pathname.includes(URL.MANAGED_SERVICES)) {
      // store the current page URL in local storage (to redirect back after login)
      const { pathname, search } = window.location;
      localStorage.setItem('previousPage', pathname + search);
    }
  };

  const headerClass = classNames(
    'w-screen h-[var(--header-height)] flex items-center justify-between px-[5vw] lg:px-[calc((100vw_-_var(--page-width))_/_2_+_(var(--page-spacing)_*_2))] py-1 text-white z-[100]',
    {
      'bg-grey-100': !variant || variant === 'grey',
      'bg-transparent': variant === 'transparent',
    },
  );

  const logo = (
    <Logo variant={variant === 'transparent' ? 'white' : 'gradient'} />
  );

  if (accessToken && user)
    return (
      <header className={headerClass}>
        {hasSideNav && (
          <Button variant="primary-thin" onClick={toggleSideNav}>
            <List size="2rem" />
          </Button>
        )}

        {logo}
      </header>
    );

  return (
    <div className={headerClass}>
      {logo}

      <div className="flex items-center gap-4 sm:gap-8">
        <ButtonLink
          to="https://www.crowdclip.com/"
          variant="primary-thin"
          colour={
            variant === 'transparent'
              ? 'white-outline-translucent'
              : 'salmon-outline'
          }
          className="hidden sm:flex"
        >
          What Is CrowdClip&reg;?
        </ButtonLink>

        <ButtonLink
          to={URL.LOGIN}
          onClick={onLoginClick}
          variant="primary-thin"
          colour={variant === 'transparent' ? 'white-salmon' : 'primary'}
          className="w-24"
        >
          Log In
        </ButtonLink>
      </div>
    </div>
  );
};

export default Header;
